import type { RouteRecordRaw } from 'vue-router';

/**
 * Shared public (pre-auth) routes — present in the single bundle for BOTH products (Phase 2.2).
 * Private, product-specific routes are installed at runtime by the router guard once `ctype` is known
 * (see router/index.ts). Paths here never collide: /login is the unified entry, /magic is the vitrine
 * magic-link landing, /verify is the full OTP step, the rest are cross-product.
 */
export const sharedRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/UnifiedLoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/magic',
    name: 'magic-link',
    component: () => import('@/views/vitrine/VitrineMagicLinkView.vue'),
    meta: { public: true },
  },
  {
    path: '/verify',
    name: 'verify',
    component: () => import('@/views/auth/VerifyOtpView.vue'),
    meta: { public: true },
  },
  {
    path: '/request-access',
    name: 'request-access',
    component: () => import('@/views/auth/RequestAccessView.vue'),
    meta: { public: true },
  },
  {
    path: '/i/:token',
    alias: '/invite/:token',
    name: 'invite',
    component: () => import('@/views/auth/InviteView.vue'),
    meta: { public: true },
  },
  // The privacy policy (CONCIERGE_CHAT_FIRST.md §15.3, CF-019) — opens without signing in; the landing links here.
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/PrivacyView.vue'),
    meta: { public: true },
  },
  {
    path: '/password/setup',
    name: 'password-setup',
    component: () => import('@/views/auth/PasswordSetupView.vue'),
  },
];
